<li class="nav-item dropdown">
  <a class="nav-link dropdown-toggle drMnenu"  href="#/{{rootModel.language}}" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    {{menu.name}}
  </a>
  <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
   <ng-template *ngFor="let child1 of menu.children"  [ngTemplateOutlet]="menulist" [ngTemplateOutletContext]="{child :child1 }"></ng-template>
 
  </ul>
</li>

<ng-template #menulist let-child="child">
        <li>
            <div *ngIf="(child.children && child.children.length == 0 ); then rootmenu else subemenu ">  </div>    
            <ng-template #rootmenu> 
                <a class="dropdown-item" routerLink="/{{rootModel.language}}/pages/{{child.external_link}}/{{strbosluk(child.name)}}"> {{child.name}} </a>              
            </ng-template>
            <ng-template #subemenu> 
              <li class="dropdown-divider"></li>
                <a class="dropdown-item dropdown-toggle" href=""> {{child.name}} </a>
                 <ul class="submenu dropdown-menu">           
                    <ng-template *ngFor="let child3 of child.children"  [ngTemplateOutlet]="menulist" [ngTemplateOutletContext]="{child :child3 }"></ng-template>
                </ul>  
               </ng-template>
        </li>
</ng-template>



<!--------------------     örnek html kodu ----------------------->
<!-- <li class="nav-item dropdown">
  <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    Dropdown link
  </a>
  <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
    <li><a class="dropdown-item" href="#">Action</a></li> 
    <li><a class="dropdown-item" href="#">arabalar</a></li> 
    <li><a class="dropdown-item" href="#">modul</a></li> 
    <li class="dropdown-divider"></li>
    <li><a class="dropdown-item dropdown-toggle" href=""> Third level 3  </a>
      <ul class="submenu dropdown-menu">
          <li><a class="dropdown-item" href=""> Fourth level 1</a></li>
          <li><a class="dropdown-item" href=""> Fourth level 2</a></li>
          <li class="dropdown-divider"></li>
          <li><a class="dropdown-item dropdown-toggle" href=""> Third level 3  </a>
            <ul class="submenu dropdown-menu">
                <li><a class="dropdown-item" href=""> Fourth level 1</a></li>
                <li><a class="dropdown-item" href=""> Fourth level 2</a></li>
            </ul>
         </li>
      </ul>
   </li>          

  </ul>
</li> -->
